import Joi from 'joi';

import { ICustomProductVariantsSectionProps } from './models';

const stringRequired = Joi.string().required();
const stringOptional = Joi.string().optional().allow('');

export const customProductVariantsSectionSchema = Joi.object<ICustomProductVariantsSectionProps>({
  variantStyle: stringRequired,
  title: stringRequired,
  text: stringRequired,
  scentsTitle: stringOptional,
  scentsList: stringOptional,
  packsTitle: stringOptional,
  packsList: stringOptional,
  imageScentOnePackOne: stringOptional,
  imageScentOnePackTwo: stringOptional,
  imageScentOnePackThree: stringOptional,
  imageScentTwoPackOne: stringOptional,
  imageScentTwoPackTwo: stringOptional,
  imageScentTwoPackThree: stringOptional,
  retailersTitle: stringRequired,
  retailersScentOnePackOne: stringOptional,
  retailersScentOnePackTwo: stringOptional,
  retailersScentOnePackThree: stringOptional,
  retailersScentTwoPackOne: stringOptional,
  retailersScentTwoPackTwo: stringOptional,
  retailersScentTwoPackThree: stringOptional,
}).options({ stripUnknown: true });
